import React from 'react';

interface ProfileAvatarWithTextProps {
  imageUrl: string | undefined;
  name: string;
  text: string;
}

export const ProfileAvatarWithText = ({
  imageUrl,
  name,
  text
}: ProfileAvatarWithTextProps) => {
  const getProfileImage = () => {
    if (!imageUrl) {
      const firstLetter = name.charAt(0).toUpperCase();
      return (
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-[#035C67] text-white text-[1.625rem] font-medium tablet:w-[4.5rem] tablet:h-[4.5rem]">
          {firstLetter}
        </div>
      );
    } else {
      return (
        <img
          src={imageUrl}
          alt={`${name} profile avatar`}
          className="w-16 h-16 rounded-full object-cover tablet:w-[4.5rem] tablet:h-[4.5rem]"
        />
      );
    }
  };

  return (
    <>
      {name && (
        <div className="mb-6 flex flex-row items-center w-full">
          {getProfileImage()}
          <div className="flex flex-col text-[1.125rem] leading-[1.625rem] ml-4">
            <div>
              <p>{text}</p>
              <p className="flex font-medium">{name}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
